import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassPointerSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCompassPointerSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.10645 16.6484L12 15.3428L16.8936 16.6484L12 6.91504L7.10645 16.6484Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassPointerSquare;
